'use client';

import { useEffect, useRef, useState, type ReactNode } from 'react';

export function useDescriptionOverflow(description: ReactNode, clampHeight: number) {
    const descriptionRef = useRef<HTMLDivElement>(null);
    const [isDescriptionOverflowing, setIsDescriptionOverflowing] = useState(false);

    useEffect(() => {
        const element = descriptionRef.current;
        if (!element || typeof ResizeObserver === 'undefined') return;

        const measure = () => setIsDescriptionOverflowing(element.scrollHeight > clampHeight);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [description, clampHeight]);

    return { descriptionRef, isDescriptionOverflowing };
}
